const API_KEY = "e5391a77880645bd70f7f99a64be26f6";
export default API_KEY;
